/**
*  料金シミュレーター
*
*  訪問リハビリテーション
*
*  @since 2019.9.24
*  @use jQuery
*/



/**
*  Variables
*
*  自己負担となる利用金額
*/

const array_visit = {
  // 基本料 [ 1割, 2割, 3割 ]
  kihon: [ 340, 681, 1022 ],
  // １週の利用日数 [ 週1日, 週2日, 週3日 ]
  week: [ 4, 8, 12 ]
}

// '1週間あたりの利用回数' の OPTION 項目の配列
const weekOptionArray = [
  '選択してください',
  '週1日',
  '週2日',
  '週3日'
];



/**
*  function
*  動作
*/

$( document ).on('click', calcBtn.rehaVisit, function(e){
  e.preventDefault();

  const formData = $( currentForm.rehaVisit ).serializeArray();
  const selectVal = selectCheck( currentForm.rehaVisit, formData );

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */

    // 結果を出して表示する
    const result = array_visit.kihon[ selectVal.futan ] * selectVal.days * selectVal.weeks;
    $( resultElm.rehaVisit ).html( numberWithComma.format( result ) );
  } // end of 計算処理開始

}); // end of event



// '1日の利用時間' を変更したとき '1週間あたりの利用回数' の内容を書き換える
$( currentForm.rehaVisit + ' [name="days"]' ).on('change', function(){
  const daysValue = this.selectedIndex;
  const weekOption = this.form.weeks;

  if ( daysValue === 2 ) {
    weekOption.textContent = null;
    weekOption.options[0] = new Option( weekOptionArray[0], '' );
    weekOption.options[1] = new Option( weekOptionArray[1], array_visit.week[0] );
    weekOption.options[2] = new Option( weekOptionArray[2], array_visit.week[1] );
	weekOption.options[3] = new Option( weekOptionArray[3], array_visit.week[2] );
  } else if ( daysValue === 1 ) {
    weekOption.options[0] = new Option( weekOptionArray[0], '' );
    weekOption.options[1] = new Option( weekOptionArray[1], array_visit.week[0] );
    weekOption.options[2] = new Option( weekOptionArray[2], array_visit.week[1] );
    weekOption.options[3] = new Option( weekOptionArray[3], array_visit.week[2] );
  } else {
    weekOption.textContent = null;
    weekOption.options[0] = new Option( weekOptionArray[0], '' );
  }
});
